export const INDEX = "index";

export const SIGN_UP = "sign-up";
export const CONFIRM_EMAIL = `${SIGN_UP}.confirm-email`;
export const CREATE_PASSWORD = `${SIGN_UP}.create-password`;
export const SIGN_UP_FINISHED = `${SIGN_UP}.finished`;

export const SELF_DIAGNOSIS = "self-diagnosis";
export const SELF_DIAGNOSIS_GENERAL_INFO = `${SELF_DIAGNOSIS}.general-info`;
// vvv NEW
export const SELF_DIAGNOSIS_FINISHED = `${SELF_DIAGNOSIS}.finished`;

export const CONSENT = "consent";
export const GUIDANCE_SELF_DIAGNOSTICS = "guidance-self-diagnostics";
export const GUIDANCE_HUMAN_BODY = "guidance-human-body";
export const AGE_INFO = "age-info";
// TODO:
// -GUIDANCE A
// -Consent
// -- QA
// -GUIDANCE B
// -- HumanModel
// -- QA
// THINKING (?) - modal
// -THANKS
// -- SIGN UP
// -- finished - DOWNLOAD THE APP

export const routes = [
  {
    name: INDEX,
    path: "/"
  },
  {
    name: CONSENT,
    path: "/consent"
  },
  {
    name: GUIDANCE_SELF_DIAGNOSTICS,
    path: "/guidance-sd"
  },
  {
    name: GUIDANCE_HUMAN_BODY,
    path: "/guidance-hb"
  },
  {
    name: AGE_INFO,
    path: "/age-info"
  },
  {
    name: SELF_DIAGNOSIS,
    path: "/self-diagnosis"
  },
  {
    name: SELF_DIAGNOSIS_GENERAL_INFO,
    path: "/general-info"
  },
  {
    name: SELF_DIAGNOSIS_FINISHED,
    path: "/finished?treatment"
  },
  {
    name: SIGN_UP,
    path: "/sign-up?token"
  },
  {
    name: CONFIRM_EMAIL,
    path: "/confirm-email?email"
  },
  {
    name: CREATE_PASSWORD,
    path: "/create-password"
  },
  {
    name: SIGN_UP_FINISHED,
    path: "/finished"
  }
];



// WEBPACK FOOTER //
// ./src/modules/routing/routes.js